import {
  faArrowLeft,
  faArrowRight,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Checkbox,
  Container,
  Grid2,
  InputAdornment,
  Radio,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import checkIcon from "../assets/images/check-icon.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import VendorSelectionCard from "../components/common/VendorSelectionCard";
import { validateForm } from "../utils/validation/direct-enquire-vendors-validation";
import productService from "../services/productService";
import vendorService from "../services/vendorService";
import Breadcrumbs from "../components/common/Breadcrumb";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import VendorSelectionCardSkeleton from "../components/common/VendorCardSkeleton";
import { ErrorHandlingDesign } from "../components/common/errorHandlingDesign";
const DirectEnquireVendors = () => {
  const [isShowResult, setIsShowResult] = useState(false);
  const [cuisines, setCuisines] = useState([]);
  const navigate = useNavigate();
  const [selectedCuisine, setSelectedCuisine] = useState(null);
  const [cuisinesDishes, setCuisinesDishes] = useState([]);
  const [selectedCuisines, setSelectedCuisines] = useState([]);
  const [submitStatus, setSubmitStatus] = useState(false);
  const [formData, setFormData] = useState({
    restaurantId: "",
    restaurantName: "",
    emailAddress: "",
    contactNo: "",
    cuisines: [],
    dishes: [],
    requirement: "",
    vendors: [],
  });
  const [errors, setErrors] = useState({});
  const [vendors, setVendors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubCatLoading, setIsSubCatLoading] = useState(true);
  const [categoryError, setCategoryError] = useState(null);
  const [subCategoryError, setSubCategoryError] = useState(null);
  const [vendorError, setVendorError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      setIsLoading(true); // Start loading
      try {
        const data = await productService.getProductCategory();
        setCuisines(data);
        if (data.length > 0) {
          setSelectedCuisine(data[0].id);
        }
        setCategoryError(null);
      } catch (err) {
        setCategoryError("Failed to load cuisine");
        console.error("Error fetching cuisine:", err);
      } finally {
        setIsLoading(false); // Stop loading
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    if (!selectedCuisine) return;

    const fetchSubCategories = async () => {
      try {
        setIsSubCatLoading(true); // Set loading to true when fetching
        const data = await productService.getProductSubCategory(
          selectedCuisine
        );
        setCuisinesDishes(data);
        setSubCategoryError(null);
      } catch (err) {
        setSubCategoryError("Failed to load dishes");

        console.error("Error fetching subcategories:", err);
      } finally {
        setIsSubCatLoading(false); // Set loading to false when done
      }
    };

    fetchSubCategories();
  }, [selectedCuisine]);

  const handleSelect = (id) => {
    setSelectedCuisines((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const handleToggle = (id) => {
    setVendors((prevVendors) =>
      prevVendors.map((vendor) =>
        vendor.id === id ? { ...vendor, selected: !vendor.selected } : vendor
      )
    );
  };
  const handlePhoneChange = (e) => {
    const value = e.target.value;
    // Allow only digits and max 10
    if (/^\d{0,10}$/.test(value)) {
      setFormData({ ...formData, contactNo: value });
    }
  };
  const handleSubmit = async () => {
    const selectedVendors = vendors
      .filter((vendor) => vendor.selected)
      .map((v) => v.name);

    const updatedFormData = {
      ...formData,
      vendors: selectedVendors,
      cuisines: [selectedCuisine],
      dishes: selectedCuisines,
    };
    const selectedCuisineData = cuisines.find((c) => c.id === selectedCuisine);
    const selectedDishesData = cuisinesDishes.filter((d) =>
      selectedCuisines.includes(d.id)
    );
    const validationErrors = validateForm(updatedFormData);
    console.log(validationErrors, "validationErrors");
    if (Object.keys(validationErrors).length === 0) {
      setSubmitStatus(!submitStatus);
      try {
        const payload = {
          restaurantId: formData.restaurantId,
          restaurantName: formData.restaurantName,
          emailAddress: formData.emailAddress,
          contactNo: formData.contactNo,
          cuisines: selectedCuisineData ? selectedCuisineData.categoryName : "",
          dishes: selectedDishesData.map((d) => d.subCategoryName).join(", "),
          vendors: selectedVendors.join(","),
          detailRequirements: formData.requirement,
        };

        await productService.submitDirectEnquiry(payload);
        setIsShowResult(true);
        setSubmitStatus(!submitStatus);
      } catch (err) {
        console.error("Enquiry submission failed:", err);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const data = await vendorService.getVendors();
        const transformed = data.map((vendor, index) => ({
          id: vendor.id,
          name: vendor.vendorName,
          location: vendor.vLocation,
          image: vendor.imageUrl,
          price: "₹17.23",
          selected: index === 0,
        }));
        setVendors(transformed);
        setVendorError(null);
      } catch (err) {
        setVendorError("Failed to load vendors");
        console.error("Error fetching vendors:", err);
      }
    };

    fetchVendors();
  }, []);

  const CuisineCardSkeleton = () => (
    <div className="cuisine-card skeleton-card">
      <Radio
        disabled
        sx={{
          color: "rgba(2,6,12,0.5)",
          "&.Mui-checked": {
            color: "#FF5200",
          },
        }}
      />
      <div className="cuisine-title">
        <Skeleton width={100} height={20} />
      </div>
      <div className="cuisine-img">
        <Skeleton height={100} width={100} circle />
      </div>
    </div>
  );
  const SubCategorySkeleton = () => (
    <div className="cuisine-card skeleton-card">
      <div className="cuisine-title">
        <Skeleton width={120} height={20} />
      </div>
      <div className="cuisine-img">
        <Skeleton height={80} width={80} circle />
      </div>
    </div>
  );
  return (
    <>
      {!isShowResult ? (
        <section className="inner-baner enquire-vendor-box">
          <Container>
            <div className="breadcrumb">
              <Breadcrumbs />
            </div>
            <div className="enquiry-form-wrap">
              <div className="enquiry-form-left-content">
                <div
                  className="back-arrow text-white"
                  onClick={() => navigate(-1)}
                  style={{ cursor: "pointer" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M10.0164 2.86402C10.5046 2.41035 11.2681 2.43834 11.7218 2.92652C12.1754 3.41471 12.1475 4.17823 11.6593 4.63189L5.9091 9.97545C5.56441 10.2958 5.27721 10.5634 5.03763 10.795L21.7309 10.795C22.3974 10.795 22.9376 11.3353 22.9376 12.0017C22.9376 12.6681 22.3974 13.2084 21.7309 13.2084L4.96299 13.2084C5.21692 13.4563 5.52784 13.7462 5.90908 14.1005L11.5886 19.3785C12.0768 19.8322 12.1048 20.5957 11.6511 21.0839C11.1974 21.5721 10.4339 21.6 9.94575 21.1464L4.20777 15.814C3.51539 15.1707 2.90681 14.6052 2.48249 14.0857C2.02422 13.5246 1.65356 12.8684 1.65356 12.0379C1.65357 11.2075 2.02424 10.5513 2.48251 9.99021C2.90682 9.47068 3.51538 8.90523 4.20774 8.26193L10.0164 2.86402Z"
                      fill="#02060C"
                      fillOpacity="0.75"
                    />
                  </svg>
                </div>
                <div className="section-title md-lg-0">
                  <h2>Send a packaging enquiry</h2>
                </div>
              </div>
              <div className="enquiry-form-right-content">
                <div className="form-card">
                  <h3>
                    Restaurant Details<sup>*</sup>
                  </h3>
                  <Grid2
                    container
                    spacing={2}
                    sx={{
                      justifyContent: "space-between",
                    }}
                  >
                    <Grid2 size={{ lg: 5, md: 5, xs: 12 }}>
                      <TextField
                        label="Swiggy Restaurant ID"
                        variant="outlined"
                        name="restaurantId"
                        value={formData.restaurantId}
                        onChange={handleChange}
                        error={!!errors.restaurantId}
                        helperText={errors.restaurantId}
                      />
                    </Grid2>
                    <Grid2 size={{ lg: 5, md: 5, xs: 12 }}>
                      <TextField
                        label="Restaurant Name"
                        variant="outlined"
                        name="restaurantName"
                        value={formData.restaurantName}
                        onChange={handleChange}
                        error={!!errors.restaurantName}
                        helperText={errors.restaurantName}
                        InputLabelProps={{
                          style: { color: "inherit" },
                        }}
                      />
                    </Grid2>
                    <Grid2 size={{ lg: 5, md: 5, xs: 12 }}>
                      <TextField
                        label="Email address"
                        variant="outlined"
                        name="emailAddress"
                        value={formData.emailAddress}
                        onChange={handleChange}
                        error={!!errors.emailAddress}
                        helperText={errors.emailAddress}
                        InputLabelProps={{
                          style: { color: "inherit" },
                        }}
                      />
                    </Grid2>
                    <Grid2 size={{ lg: 5, md: 5, xs: 12 }}>
                      <TextField
                        value={formData.contactNo}
                        inputProps={{ maxLength: 10 }}
                        error={!!errors.contactNo}
                        helperText={errors.contactNo}
                        onChange={(e) => handlePhoneChange(e)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <div className="number-wrapper">
                                <span className="number-start-indian">+91</span>
                                <div className="number-strip" />
                              </div>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid2>
                  </Grid2>
                </div>
                <div className="form-card">
                  <h3>Select Cuisine</h3>
                  <div className="select-cuisine-slider-wrap">
                    <Swiper
                      modules={[Navigation]}
                      slidesPerView={"auto"}
                      spaceBetween={20}
                      className="select-cuisine-slider"
                      navigation={{
                        nextEl: ".custom-next",
                        prevEl: ".custom-prev",
                        clickable: true,
                      }}
                    >
                      {categoryError ? (
                        <ErrorHandlingDesign errorMessage={categoryError} />
                      ) : isLoading ? (
                        Array.from({ length: 5 }).map((_, index) => (
                          <SwiperSlide key={index}>
                            <CuisineCardSkeleton />
                          </SwiperSlide>
                        ))
                      ) : (
                        cuisines.map((cuisine) => (
                          <SwiperSlide key={cuisine.id}>
                            <div
                              className={`cuisine-card ${
                                selectedCuisine === cuisine.id ? "selected" : ""
                              }`}
                              onClick={() => setSelectedCuisine(cuisine.id)}
                            >
                              <Radio
                                sx={{
                                  color: "rgba(2,6,12,0.5)",
                                  "&.Mui-checked": {
                                    color: "#FF5200",
                                  },
                                }}
                                checked={selectedCuisine === cuisine.id}
                                value={cuisine.id}
                                name="radio-buttons"
                              />
                              <div className="cuisine-title text-med-emphasis">
                                {cuisine.categoryName}
                              </div>
                              <div className="cuisine-img">
                                <img
                                  src={cuisine.imageURL}
                                  alt={cuisine.categoryName}
                                />
                              </div>
                            </div>
                          </SwiperSlide>
                        ))
                      )}
                    </Swiper>
                    <button className="custom-prev slider-arrow">
                      <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                    <button className="custom-next slider-arrow">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </button>
                  </div>
                </div>

                <div className="form-card">
                  <h3>
                    Select Dish <sup>*</sup>
                  </h3>

                  {subCategoryError || categoryError ? (
                    <ErrorHandlingDesign
                      errorMessage={"Failed to load dishes"}
                    />
                  ) : isSubCatLoading ? (
                    <div className="select-dish-wrap select-cuisine-package">
                      {Array.from({ length: 5 }).map((_, index) => (
                        <div key={index} className="select-dish-item">
                          <SubCategorySkeleton />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="select-dish-wrap select-cuisine-package">
                      {cuisinesDishes.map((dish) => (
                        <div key={dish.id} className="select-dish-item">
                          <div
                            className={`cuisine-card ${
                              selectedCuisines.includes(dish.id)
                                ? "selected"
                                : ""
                            }`}
                            onClick={() => handleSelect(dish.id)}
                          >
                            <Checkbox
                              checked={selectedCuisines.includes(dish.id)}
                              sx={{
                                color: "rgba(2,6,12,0.5)",
                                "&.Mui-checked": {
                                  color: "#FF5200",
                                },
                              }}
                              value={dish.id}
                              name="check-buttons"
                            />
                            <div className="cuisine-title text-med-emphasis">
                              {dish.subCategoryName}
                            </div>
                            <div className="cuisine-img">
                              <img
                                src={dish.imageURL}
                                alt={dish.subCategoryName}
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  {errors.dishes && (
                    <p className="Mui-error mt-30">{errors.dishes}</p>
                  )}
                </div>

                <div className="form-card">
                  <h3>
                    Select Vendors<sup>*</sup>
                  </h3>
                  {vendorError ? (
                    <ErrorHandlingDesign errorMessage={vendorError} />
                  ) : (
                    <>
                      <Grid2
                        container
                        spacing={2}
                        className="select-vendor-wrap"
                      >
                        {vendors.length === 0
                          ? Array.from({ length: 3 }).map((_, index) => (
                              <Grid2
                                key={index}
                                size={{ sm: 6, md: 4, lg: 4, xs: 12 }}
                              >
                                <VendorSelectionCardSkeleton />
                              </Grid2>
                            ))
                          : vendors.map((vendor) => (
                              <Grid2
                                key={vendor.id}
                                size={{ sm: 6, md: 4, lg: 4, xs: 12 }}
                              >
                                <VendorSelectionCard
                                  vendor={vendor}
                                  onToggle={handleToggle}
                                />
                              </Grid2>
                            ))}
                        <Grid2 size={12} className="mob-none">
                          <div className="note">
                            <FontAwesomeIcon icon={faExclamationCircle} />
                            We’ll send your enquiry to the vendors you select
                          </div>
                        </Grid2>
                      </Grid2>
                      {errors.vendors && (
                        <p className="Mui-error">{errors.vendors}</p>
                      )}
                    </>
                  )}
                </div>
                <div className="form-card">
                  <h3>Describe Your Requirements</h3>
                  <Grid2 container spacing={2}>
                    <Grid2 size={12}>
                      <TextField
                        id="requirement"
                        variant="outlined"
                        multiline
                        minRows={5}
                        maxRows={10}
                        placeholder="Custom requirements like logo branding on the packaging, Multiple products enquiry etc..."
                        name="requirement"
                        value={formData.requirement}
                        onChange={handleChange}
                      />
                    </Grid2>
                  </Grid2>
                </div>
                <div className="enquiry-submit-btn">
                  <button
                    className={`btn btn-orange ${
                      submitStatus ? "disabled" : ""
                    }`}
                    type="button"
                    onClick={handleSubmit}
                    disabled={submitStatus}
                  >
                    {submitStatus ? "Sending..." : "Send an enquiry"}
                  </button>
                </div>
              </div>
            </div>
          </Container>
        </section>
      ) : (
        <section className="enquiry-result-status">
          <Container>
            <Grid2 container spacing={2}>
              <Grid2 size={12}>
                <div className="success-msg">
                  <img src={checkIcon} alt="" />
                  <h2>Your enquiry has been sent successfully!</h2>
                  <p>
                    We have sent you a confirmation via email and SMS. The
                    vendor will reach out to you shortly.
                  </p>
                  <Link to={"/"} className="btn btn-orange" type="button">
                    Continue Browsing
                  </Link>
                </div>
              </Grid2>
            </Grid2>
          </Container>
        </section>
      )}
    </>
  );
};

export default DirectEnquireVendors;
